// SINGLE SOURCE OF TRUTH for every color in the app.
// Every component references these via CSS variables: var(--c-brand), etc.
// The brand color is the ramp below (--c-brand*). Change it here and it changes everywhere.
export const T = {
  "--brand-a0_08": "rgba(52, 168, 83, 0.08)",
  "--brand-a0_3": "rgba(52, 168, 83, 0.3)",
  "--brand-a0_4": "rgba(52, 168, 83, 0.4)",
  "--c-111827": "#111827",
  "--c-1a1a1a": "#1a1a1a",
  "--c-333333": "#333333",
  "--c-374151": "#374151",
  "--c-6b7280": "#6b7280",
  "--c-9ca3af": "#9ca3af",
  "--c-a8a8a8": "#a8a8a8",
  "--c-brand": "#34a853",
  "--c-brand-dark": "#278842",
  "--c-brand-hover": "#2f9a4c",
  "--c-c1c1c1": "#c1c1c1",
  "--c-d32f2f": "#d32f2f",
  "--c-d97706": "#d97706",
  "--c-dc2626": "#dc2626",
  "--c-e5e7eb": "#e5e7eb",
  "--c-ef4444": "#ef4444",
  "--c-f1f1f1": "#f1f1f1",
  "--c-f59e0b": "#f59e0b",
  "--c-f5f5f5": "#f5f5f5",
  "--c-f87171": "#f87171",
  "--c-f8f9fa": "#f8f9fa",
  "--c-fbbf24": "#fbbf24",
  "--c-fecaca": "#fecaca",
  "--c-ffffff": "#ffffff",
  "--rgba-0-0-0-a0_08": "rgba(0, 0, 0, 0.08)",
  "--rgba-255-255-255-a0_12": "rgba(255, 255, 255, 0.12)",
  "--rgba-255-255-255-a0_9": "rgba(255, 255, 255, 0.9)",
};

// :root CSS variable block, generated from T. Injected once in main.jsx.
export const cssText = ":root{\n" +
  Object.entries(T).map(([k, v]) => "  " + k + ":" + v + ";").join("\n") +
  "\n}";

export default T;
